<template>
  <div class="customerService">
    <topTitle
      :title=shopInfo.member_name
    >
    <button @click="toshop(shopInfo.shop_id)" >进店</button>
    </topTitle>
    <div class="customerTel" > 
      
          <a :href="'tel:'+shopInfo.link_phone">客服电话：{{shopInfo.link_phone}}</a>
          <p>如需咨询，请拨打商家电话进行咨询。</p>
    </div>
  </div>
</template>

<script>
import topTitle from "../../components/topTitle.vue";

export default {
  name: "customerService",
  data() {
    return {
      shopInfo:this.$route.query.shopPhone,
    };
  },
  components: {
    topTitle
  },
  mounted(){
  },
  methods: {
   topHandle(){
	   this.$router.push('./shopIndex')
   },
   toshop(shopid){
      this.$router.push({
        path :'./shopIndex',
        query :{
          shop_id : shopid
        }
      })
   }
  }
};
</script>


<style scoped lang='less'>
/deep/ .topTitle{
 /deep/ button{
    background: linear-gradient(to right, #FF5145, #E52F23, #CD0F02);
    width: 74px;
    height: 44px;
    border-radius: 20px;
    text-align: center;
    line-height: 44px;
    color: #fff;
    font-size: 20px;
  }
}
.customerTel{
  text-align: center;
  margin-top: 202px;
  a{
    display: inline-block;
    width: 590px;
    height: 88px;
    margin: 0 auto;
    text-align: center;
    line-height: 88px;
    color: #fff;
    font-size: 36px;
    background: linear-gradient(to right,#FFB630,#FE7B01);
    border-radius: 40px;
  }
  p{
    color: #777777;
    font-size: 26px;
    margin-top: 34px;
  }
}
</style>


